import type { ReactNode } from 'react';
import type { BoxInfo, CardInfo } from '@lub0v/santa-utils';
import { HangingGameSign } from './HangingGameSign';

export interface GameHeaderProps {
  info: BoxInfo;
  cards: CardInfo[];
  onChanged: () => Promise<void> | void;
  main?: boolean;
  navigation?: ReactNode;
}

export function GameHeader({ info, cards, onChanged, main = false, navigation }: GameHeaderProps) {
  return (
    <header
      className={`desktop-exchange-heading${main ? ' desktop-exchange-heading--main' : ''}`}
      data-testid="game-header"
    >
      {navigation}
      {main && <HangingGameSign cards={cards} info={info} onChanged={onChanged} />}
    </header>
  );
}
